<template>
  <div v-if="mainDebug == true">
    <base-collapse v-model="activeNames" @change="handleChange">
      <base-collapse-item title="Master Debug" name="0">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <base-collapse-item
              title="Product classification search criteria"
              name="1"
            >
              <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <div class="row">
                    <div class="col-md-3 class_header">~Country :</div>
                    <div class="col-md-9">{{ prodClassCriteria.country }}</div>
                  </div>
                  <div class="row">
                    <div class="col-md-3 class_header">
                      Medical Device Type :
                    </div>
                    <div class="col-md-9">
                      {{ prodClassCriteria.medical_device_type }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-3 class_header">
                      Kit Component Pass Counter :
                    </div>
                    <div class="col-md-9">
                      {{ ivdrCurrCtr }}--{{ prodClassCriteria.componentName }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-3 class_header">
                      Medical Product Name :
                    </div>
                    <div class="col-md-9">
                      {{ prodClassCriteria.device_name }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-3 class_header">
                      Classification Finalized :
                    </div>
                    <div class="col-md-9">
                      {{ prodClassCriteria.classificationFinalized }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-3 class_header">Level Array:</div>
                    <div class="col-md-9">{{ sortedLevelArray }}</div>
                  </div>
                  <div class="row">
                    <div class="col-md-3 class_header">Level Array (Kit):</div>
                    <div class="col-md-9">{{ sortedLevelArrayKit }}</div>
                  </div>
                </div>
              </div>
            </base-collapse-item>
            <base-collapse-item
              title="Classification Questions and Responses"
              name="2"
            >
              <div>
                <div>
                  <div class="row class_header">
                    <div class="col-xs-1">Step</div>
                    <div class="col-md-4">Question</div>
                    <div class="col-md-3">Response</div>
                    <div class="col-xs-1">Level</div>
                    <div class="col-md-1">Interim Class</div>
                    <div class="col-md-1">Rule Ref</div>
                  </div>

                  <div
                    v-for="(data, index) in workflowDataArray"
                    v-bind:key="index"
                    class="row"
                  >
                    <div class="col-xs-1">{{ index + 1 }}</div>
                    <div class="col-md-4">{{ data.question }}</div>
                    <div class="col-md-3">{{ data.answer }}</div>
                    <div class="col-xs-1">{{ data.level }}</div>
                    <div class="col-md-1">{{ data.interimClass }}</div>
                    <div class="col-md-1">{{ data.ruleRef }}</div>
                  </div>
                </div>
              </div></base-collapse-item
            >
            <base-collapse-item title="Classification Misc" name="3">
              <div>
                <div>
                  <div class="row">
                    <div class="col-md-3">Classification Code:</div>
                    <div class="col-md-9">
                      {{ prodClassCriteria.compositeArrayWrapper.classCode }}-{{
                        prodClassCriteria.compositeArrayWrapper.classFoundFlag
                      }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-3">Classification Data:</div>
                    <div class="col-md-9">{{ classData }}</div>
                  </div>
                  <div class="row">
                    <div class="col-md-3">Choices:</div>
                    <div class="col-md-9">
                      {{ prodClassCriteria.searchCriteriaArray }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-3">Workflow ResponseCache Component</div>
                  </div>
                  <div class="col-md-2">Component Name</div>
                  <div class="col-md-3">Class Code</div>
                  <div class="col-md-7">Data Cache</div>
                  <div
                    v-for="(
                      data, key, index
                    ) in prodClassCriteria.workflowResponseMap"
                    v-bind:key="index"
                  >
                    <div class="col-md-2">{{ data[1].name }}</div>
                    <div class="col-md-3">{{ data[1].classCode }}</div>
                    <div class="col-md-7">{{ data[1].cache.length }}</div>
                  </div>
                  <div class="row">
                    <div class="col-md-3">Level Array Component</div>
                  </div>
                  <div class="col-md-2">Component Name</div>
                  <div class="col-md-3">Class Code</div>
                  <div class="col-md-7">Data Cache</div>
                  <div
                    v-for="(
                      lvlArr, key, index
                    ) in prodClassCriteria.mapLevelArray"
                    v-bind:key="index"
                  >
                    <div class="col-md-2">{{ key }}</div>
                    <div class="col-md-3">{{ index }}</div>
                    <div class="col-md-7">{{ lvlArr[1] }}</div>
                  </div>
                </div>
              </div>
            </base-collapse-item>
            <base-collapse-item title="Workflow Response Cache(es)" name="4">
              <div>
                <div>
                  <div class="row">
                    <div class="col-md-3">Workflow Response Cache Size :</div>
                    <div class="col-md-9">
                      {{ prodClassCriteria.workflowResponseMap.size }}
                    </div>
                  </div>
                </div>
                <div>
                  <div class="row">
                    <div class="col-md-3">
                      Workflow Response Cache Component :
                    </div>
                    <div class="col-md-9">
                      {{ prodClassCriteria.workflowResponseMap.entries() }}
                    </div>
                  </div>
                </div>
                <div>
                  <div class="row">
                    <div class="col-md-3">Workflow Response Cache :</div>
                    <div class="col-md-9">
                      {{ prodClassCriteria.workflowResponseCache }}
                    </div>
                  </div>
                </div>
                <div>
                  <div class="col-md-12">Search Criteria Data :</div>
                  <div class="row">
                    <div
                      class="col-md-9"
                      v-for="(cache, keyMod, index) in criteriaMap"
                      v-bind:key="keyMod"
                    >
                      {{ cache }} ------- {{ index }} ------- {{ keyMod }}
                    </div>
                  </div>
                </div>
              </div>
            </base-collapse-item>
          </div>
        </div>
      </base-collapse-item>
    </base-collapse>
  </div>
</template>
<script>
import BaseCollapse from '../../Common/BaseCollapse.vue';
import BaseCollapseItem from '../../Common/BaseCollapseItem.vue';

export default {
  components: { BaseCollapse, BaseCollapseItem },
  props: [
    'prodClassCriteria',
    'mainDebug',
    'ivdrCurrCtr',
    'criteriaMap',
  ],
  data() {
    return {
      activeNames: [''],
    };
  },
  computed: {
    classData() {
      const classData = {
        code: this.prodClassCriteria.compositeArrayWrapper.classCode,
        flag: this.prodClassCriteria.compositeArrayWrapper.classFoundFlag,
      };
      return classData;
    },
    sortedLevelArray() {
      const sortedLevelAray = this.prodClassCriteria.levelArray;
      return sortedLevelAray;
    },
    sortedLevelArrayKit() {
      const sortedLevelAray = [
        ...this.prodClassCriteria.mapLevelArray.values(),
      ];
      return sortedLevelAray;
    },
    arrayLengths() {
      const arrLengthHolder = {
        srch_cri_arr_len: this.prodClassCriteria.searchCriteriaArray
          ? this.prodClassCriteria.searchCriteriaArray.length
          : null,
        wf_resp_arr: this.prodClassCriteria.workflowResponseCache
          ? this.prodClassCriteria.workflowResponseCache.length
          : null,
      };
      return arrLengthHolder;
    },
    workflowDataArray() {
      const workflowDataArray = [];
      let indx = 0;
      const wfResponseCache = this.prodClassCriteria.workflowResponseCache;
      if (wfResponseCache && wfResponseCache.length > 0) {
        wfResponseCache.forEach((srchCritArrElement) => {
          if (srchCritArrElement) {
            const currTitleDataAndChildOptions = srchCritArrElement.response_data;
            const { choices } = srchCritArrElement;
            let answer = '';
            let levelComputed = '';
            let ruleRef = '';
            let intClass = '';
            if (Array.isArray(choices)) {
              choices.forEach((e) => {
                const valArray = e.split('|');
                answer += `${valArray[0]},`;
                levelComputed += `${valArray[2]},`;
                ruleRef += !valArray[6] ? `${valArray[6]},` : '';
                intClass += !valArray[5] ? `${valArray[5]},` : '';
              });
            } else {
              const valArray = choices.split('|');
              [answer] = valArray;
              levelComputed += valArray[2];
              [, , , , , , ruleRef] = valArray;
              [, , , , , intClass] = valArray;
            }

            const workflowDataIns = {
              step: (indx += 1),
              question: currTitleDataAndChildOptions.vital_characteristic,
              answer,
              level: levelComputed,
              interimClass: intClass,
              ruleRef,
            };
            workflowDataArray.push(workflowDataIns);
          }
        });
      }
      return workflowDataArray;
    },
  },
  methods: {
    handleChange() {},
  },
  mounted() {},
};
</script>
<style scoped>
.class_header {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 15.5px;
  line-height: 23px;
  display: flex;
  align-items: center;
  color: #00518a;
}
</style>
